import $ from 'jquery';

$(function () {
  return $('.grab-a-badge').on('click', 'input[type=radio]', function (e) {
    $('.power-100-badge').addClass('hidden');
    $($(e.target).data('badge-id')).removeClass('hidden');
    return $('#badge-code').text($(e.target).data('code-snippet'));
  });
});
